export default () => ({
    open: false,
    themes: ['light', 'dark', 'system'],
    selectedTheme: 'light',
    isThemeSelected(theme) {
        return theme === this.selectedTheme;
    },
    isDarkTheme(theme) {
        const isSystem = theme === "system";

        return theme === "dark" || (isSystem && window.matchMedia("(prefers-color-scheme: dark)").matches);
    },
    selectTheme(theme) {
        this.selectedTheme = theme;

        window.localStorage.setItem('currentTheme', this.selectedTheme);

        const data = new FormData();
        data.append('is_dark_theme', this.isDarkTheme(theme));
        data.append('csrf_token', window.csrfToken());
        axios.post('/switch-theme', data);

        this.$dispatch('change-appearance-mode', {theme: this.selectedTheme});

        this.toggleOpen();
    },
    toggleOpen() {
        this.open = !this.open;
    },
    closeDropdown() {
       this.open = false;
    },
    init() {
        this.selectedTheme = window.localStorage.getItem('currentTheme') || 'light';

        document.addEventListener('change-appearance-mode', (event) => {
            this.selectedTheme = event.detail.theme;
        });
    }
})
